module.exports = __webpack_public_path__ + "img/undraw_social_distancing_2g0u.d49c2697.svg";